import { z } from "zod";
import { emailSchema } from "../common/email.js";

export const requestOtpSchema = z.object({
	email: emailSchema,
	community_slug: z
		.string()
		.regex(/^[a-z0-9-]+$/)
		.min(2)
		.max(64)
		.nullish(),
});

export type RequestOtpPayload = z.infer<typeof requestOtpSchema>;
